import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    localStorage.removeItem('brazil')
    localStorage.removeItem('brazil_overview')
    localStorage.removeItem('world')
    localStorage.removeItem('world_overview')
  }
}
